// extracted by mini-css-extract-plugin
export var quantityInput = "_nk-0";